<template>
    <div class="pretty">
        <div class="image">
            <slot name="image"></slot>
        </div>
        <div class="title">
            <slot name="content"></slot>
        </div>
        <div class="actions">
            <slot name="actions"></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: "RichPrettyInfo"
    }
</script>

<style scoped lang="scss">
    .pretty{
        display:flex;
        justify-content: space-between;
        flex-direction: column;
        align-items: center;
        margin: 54px 0;
        height: calc(100vh - 164px);
        text-align: center;
    }
    .title{
        margin-bottom: 32px;
    }
    .image{
        /deep/ img{
            height: 120px;
            width: 120px;
        }
    }
    @include screen-xs{
        .image{
            /deep/ img{
                height: 160px;
                width: 160px;
            }
        }
    }
    @include screen-m{
        .image{
            /deep/ img{
                height: 200px;
                width: 200px;
            }
        }
        .pretty{
            display:block;
            height: auto;
            max-width: 400px;
            margin: 54px auto;
        }
    }
</style>
